import { baseService } from "../base";
import { PaginationResponse } from "../type";
import { CreateVendorDto, GetVendorParams } from "./vendor.types";
import { TVendor } from "~/types";

export const vendorService = {
  getVendors: async (params?: GetVendorParams) => {
    const { data } = await baseService.get<PaginationResponse<TVendor>>(
      "/vendors",
      {
        params,
      }
    );
    return data;
  },
  createVendor: async (payload: CreateVendorDto) => {
    const { data } = await baseService.post("/vendors", payload);
    return data;
  },
  updateVendor: async ({
    vendorId,
    payload,
  }: {
    vendorId: string;
    payload: CreateVendorDto;
  }) => {
    const { data } = await baseService.patch(`/vendors/${vendorId}`, payload);
    return data;
  },
  deleteVendor: async (vendorId: string) => {
    const { data } = await baseService.delete(`/vendors/${vendorId}`);
    return data;
  },
};
